import { Box } from "@chakra-ui/react";
import { FormsetWrapper } from "../components/FormWrapper";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTutorApplicationFlow } from "../components/FormWrapper";
import { IRootStore } from "../stores";
import { STEPS } from "../stores/utils";
import WorkHistory from "../tutor-revamp/WorkHistory";

type Props = {
  store: IRootStore;
};

const WorkHistoryPage = ({ store }: Props) => {
  const { getFormWrapperProps } = useTutorApplicationFlow(store);
  const workProps = getFormWrapperProps(STEPS.EDUCATION_HISTORY);

  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <FormsetWrapper
        buttonProps={{
          isLoading: store.loading,
          onClick: () => store.onFormSubmit({}, STEPS.WORK_HISTORY, ""),
        }}
        buttonText={workProps.buttonText}
        header={workProps.formHeader}
        description={workProps.formsetDescription}
        shouldDisplayButton={false}
        hideStep
      >
        <WorkHistory {...getFormWrapperProps(STEPS.WORK_HISTORY)} />
      </FormsetWrapper>
    </Box>
  );
};

export default observer(WorkHistoryPage);
